export const ROOT = 'pollsViewer';
export const PRESET_SELECTOR_MODAL = 'presetSelectorModal';
export const TEXT_LIST_OPTION = 'textListOption';
export const IMAGE_AND_LIST_OPTION = 'imageAndListOption';
export const IMAGE_GRID_OPTION = 'imageGridOption';

//Both editor and viewer
export const POLLS_MULTIPLE_ANSWER_TEXT = 'pollsMultipleAnswerText';
export const POLLS_QUESTION_IMAGE = 'pollsQuestionImage';
export const POLLS_ANSWER_IMAGE = 'pollsAnswerImage';
export const POLLS_ANSWER_ITEMS = 'pollsAnswerItems';
export const POLLS_QUESTION_TEXT_INPUT = 'pollsQuestionTextInput';
export const POLLS_ANSWER_TEXT_INPUT = 'pollsAnswerTextInput';

//Edit Mode
export const POLLS_ADD_ANSWER_BUTTON = 'pollsAddAnswerItemButton';
export const POLLS_REMOVE_ANSWER_BUTTON = 'pollsRemoveAnswerItemButton';

//Preview Mode
export const POLLS_ITEM_PERCENTAGE_PREVIEW = 'pollsItemsPercentagePreview';

//Toolbar
export const POLLS_DROPDOWN_CUSTOMIZE_LAYOUT = 'poll_layout_modal_button';

// Settings modal
export const POLLS_SETTINGS_MODAL = 'polls-settings';
export const POLLS_SETTINGS_TABS = 'polls-settings-tabs';
export const POLLS_SETTINGS_LAYOUT_TAB = 'polls-layout-tab';
export const POLLS_SETTINGS_DESIGN_TAB = 'polls-design-tab';
export const POLLS_SETTINGS_SETTINGS_TAB = 'polls-settings-tab';

// Settings - Layout tab
export const POLLS_IMAGE_TO_QUESTION_TOGGLE = 'pollsImageToQuestionToggle';
export const POLLS_IMAGE_TO_ANSWERS_TOGGLE = 'pollsImageToAnswersToggle';

export const POLL_LAYOUT_LIST = 'pollsLayoutList';
export const POLL_LAYOUT_GRID = 'pollsLayoutGrid';

export const POLL_DIRECTION_LTR = 'pollsDirectionLTR';
export const POLL_DIRECTION_RTL = 'pollsDirectionRTL';

// Settings - Design tab
export const POLL_BACKGROUND_COLOR = 'pollsDesignBackgroundColor';
export const POLL_BACKGROUND_COLOR_PICKER = 'pollsDesignBackgroundColorPicker';
export const POLL_BACKGROUND_GRADIENT = 'pollsDesignBackgroundGradient';
export const POLL_BACKGROUND_IMAGE = 'pollsDesignBackgroundImage';
export const POLL_CORDER_RADIUS_SLIDER = 'pollsDesignBorderRadiusSlider';
export const POLL_CORDER_RADIUS_INPUT = 'pollsDesignBorderRadiusInput';
export const ANSWERS_CORNER_RADIUS_SLIDER = 'pollsDesignAnswersCornerRadiusSlider';
export const ANSWERS_CORNER_RADIUS_INPUT = 'pollsDesignAnswersCornerRadiusInput';

// Settings - Settings tab
export const POLLS_MULTIPLE_ANSWERS_TOGGLE = 'pollsMultipleAnswersToggle';
export const POLLS_VOTE_COUNT_TOGGLE = 'pollsVoteCountToggle';
export const POLLS_EACH_PERSON_VOTE_TOGGLE = 'pollsEachPersonVoteToggle';

export const POLL_VISIBILITY_OPTION_EVERYONE = 'pollsVisibilityResultEveryone';
export const POLL_VISIBILITY_OPTION_VOTERS = 'pollsVisibilityResultVoters';
export const POLL_VISIBILITY_OPTION_CREATOR = 'pollsVisibilityResultCreator';
